/* globals gtag */

// Send event to Google Analytics, using the gtag library
// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export const sendAnalyticsEvent = (eventName, parameters = {}) => {
  if (typeof gtag !== 'undefined') {
    gtag('event', eventName, parameters);
  }
};
